import React, { createContext, useContext, useState } from 'react';

const TournamentContext = createContext();

export const TournamentProvider = ({ children }) => {
  const [tournaments, setTournaments] = useState([]);

  return (
    <TournamentContext.Provider value={{ tournaments, setTournaments }}>
      {children}
    </TournamentContext.Provider>
  );
};

export const useTournamentContext = () => {
  return useContext(TournamentContext);
};
